import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Control, Form, Errors } from 'react-redux-form';
import { renderNewTextField, renderErrorInfoText } from '../common/forms/FieldCreators';
import ViewHeaderBar from '../components/ViewHeaderBar';
import { localizations } from '../localization/localization';
import ButtonContainer from '../components/ButtonContainer';
import * as LoginStore from './loginStore'
import { ChangePasswordModel } from './LoginModels';
import nameof from '../utils/nameof';
import { connect } from 'react-redux';
import * as Store from "../register/user/registerUserStore";
import FormItem from '../components/forms/FormItem';
import * as validators from '../common/validators/formValidators'

const styles = () => ({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "400px",
    }
});

type WithStylesProps = "root";
type ChangePasswordProps = WithStyles<WithStylesProps> & typeof LoginStore.actionCreators & typeof Store.actionCreators

const ChangePassword: React.SFC<ChangePasswordProps> = (props) => {

    const { classes } = props;
    return <Grid className={classes.root}>
        <Form hideNativeErrors model="changePasswordModel" onSubmit={props.changePasswordSubmit} validators={{
            '': {
                passwordOk: (vals) => vals.oldPassword !== vals.newPassword,
                newPasswordsOk: (vals) => vals.newPassword === vals.confirmNewPassword
            },
        }}>
            <Grid container direction="column">
                <ViewHeaderBar title={localizations.login.changePassword} />
                <FormItem>
                    <Control required validators={{ required: validators.required }} validateOn={["blur", "change"]} model={`.${nameof<ChangePasswordModel>("oldPassword")}`} component={renderNewTextField} type="password" label={localizations.login.oldPassword} />
                    <Errors model={`.${nameof("oldPassword")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                </FormItem>
                <FormItem>
                    <Control model={`.${nameof<ChangePasswordModel>("newPassword")}`} required validators={{ isValidPassword: validators.isvalidPassword }} component={renderNewTextField} type="password" label={localizations.login.newPassword} />
                    <Errors model={`.${nameof("newPassword")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    <Errors model={`.${nameof("newPassword")}`} show={{ touched: true, focus: false }} messages={{ isValidPassword: localizations.validation.validPassword }} wrapper={renderErrorInfoText} />
                    <Errors model="changePasswordModel" show={{ touched: true, focus: false }} messages={{ passwordOk: localizations.validation.passwordsMatch }} wrapper={renderErrorInfoText} />
                </FormItem>
                <FormItem>
                    <Control model={`.${nameof<ChangePasswordModel>("confirmNewPassword")}`} required validators={{ isValidPassword: validators.isvalidPassword }} component={renderNewTextField} type="password" label={localizations.login.confirmNewPassword} />
                    <Errors model={`.${nameof("confirmNewPassword")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    <Errors model="changePasswordModel" show={{ touched: true, focus: false }} messages={{ newPasswordsOk: localizations.validation.newPasswordsMatch }} wrapper={renderErrorInfoText} />
                </FormItem>
                <FormItem>
                    <ButtonContainer>
                        <Button variant="contained" color="secondary" type="submit">{localizations.login.changePassword}</Button>
                    </ButtonContainer>
                </FormItem>
            </Grid>
        </Form>
    </Grid>
    }
export default withStyles(styles)(connect(null, LoginStore.actionCreators)(ChangePassword));


// WEBPACK FOOTER //
// ./src/login/ChangePassword.tsx